export const RC = 0;
export const DEVELOP = "0";
export const VERSION = `4.1.${DEVELOP}`;
export const FROALA_KEY = "SB3B17A11A8jC5D4H4G4J2A7A8C4B4D2A-9pffpuA6kfgE4ob==";

// ############################################################################
// #         Develop configuration                                            #
// ############################################################################
export const XLS_DEVELOP = "https://rebusxls.com";
export const PAY_URL_DEVELOP = "https://rebus-v4-pay.herokuapp.com";
export const AI_URL_DEVELOP = "https://rebus-v4-ai.herokuapp.com";
export const BACKEND_DEVELOP = "https://rebus-v4-dev.herokuapp.com";
export const BACKENDV5_DEVELOP = "https://rebus-v5-dev.herokuapp.com";
export const XLS_TEMPLATES_DEVELOP = {
  // tslint:disable-next-line:max-line-length
  "7-user-email": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "8-user-code": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "endpoint1": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "upload_calendars": "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/templateExcel%2Fupload_calendars.xlsx?alt=media&token=894e3136-c630-4c69-9956-ebe6a665fcfc",
  // tslint:disable-next-line:max-line-length
  "users": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Templates%2Fupload_users_03122018.xlsx?alt=media&token=2cd0c1ab-a104-4dad-9abb-fead35484e67",
  // tslint:disable-next-line:max-line-length
  "users_club": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Templates%2FplantillaClubes.xlsx?alt=media&token=62cb52ff-5325-420d-8c19-4cbe1e746140",
  // tslint:disable-next-line:max-line-length
  "users_payment_club": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/datos_de_club.xlsx?alt=media&token=166f6104-f8b8-412c-8612-3e11edbb01ad",
  // tslint:disable-next-line:max-line-length
  "users_upload_coupons": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Plantilla%20carga%20cupones.xlsx?alt=media&token=633c85d8-2288-4b4b-8ddc-2ccd2f97988d",
};
export const LANGUAGES_DEVELOP = [
  { key: "es", value: "Spanish" },
  { key: "en", value: "English" },
];
export const FIREBASE_DEVELOP = {
  apiKey: "AIzaSyCb1iBrN5sJT_r-qN_us-9ArgOo5BtsEjE",
  authDomain: "rebus-v4.firebaseapp.com",
  databaseURL: "https://rebus-v4.firebaseio.com",
  messagingSenderId: "709449322010",
  projectId: "rebus-v4",
  storageBucket: "rebus-v4.appspot.com",
};
// ############################################################################
// #         Staging configuration                                            #
// ############################################################################
export const XLS_STAGING = "https://rebusxls.com";
export const PAY_URL_STAGING = "https://rebus-v4-pay.herokuapp.com";
export const AI_URL_STAGING = "https://rebus-v4-ai.herokuapp.com";
export const BACKEND_STAGING = "https://rebus-v4-dev.herokuapp.com";
export const BACKENDV5_STAGING = "https://rebus-v5-dev.herokuapp.com";
export const XLS_TEMPLATES_STAGING = {
  // tslint:disable-next-line:max-line-length
  "7-user-email": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "8-user-code": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "endpoint1": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "upload_calendars": "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/templateExcel%2Fupload_calendars.xlsx?alt=media&token=894e3136-c630-4c69-9956-ebe6a665fcfc",
  // tslint:disable-next-line:max-line-length
  "users": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Templates%2Fupload_users_03122018.xlsx?alt=media&token=2cd0c1ab-a104-4dad-9abb-fead35484e67",
  // tslint:disable-next-line:max-line-length
  "users_club": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Templates%2FplantillaClubes.xlsx?alt=media&token=62cb52ff-5325-420d-8c19-4cbe1e746140",
  // tslint:disable-next-line:max-line-length
  "users_payment_club": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/datos_de_club.xlsx?alt=media&token=166f6104-f8b8-412c-8612-3e11edbb01ad",
  // tslint:disable-next-line:max-line-length
  "users_upload_coupons": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Plantilla%20carga%20cupones.xlsx?alt=media&token=633c85d8-2288-4b4b-8ddc-2ccd2f97988d",
};
export const LANGUAGES_STAGING = [
  { key: "es", value: "Spanish" },
  { key: "en", value: "English" },
];
export const FIREBASE_STAGING = {
  apiKey: "AIzaSyCb1iBrN5sJT_r-qN_us-9ArgOo5BtsEjE",
  authDomain: "rebus-v4.firebaseapp.com",
  databaseURL: "https://rebus-v4.firebaseio.com",
  messagingSenderId: "709449322010",
  projectId: "rebus-v4",
  storageBucket: "rebus-v4.appspot.com",
};
// ############################################################################
// #         Production configuration                                         #
// ############################################################################
export const XLS_PRODUCTION = "https://rebusxls.com";
// export const PAY_URL_PRODUCTION = 'https://payment-dot-rebus-v4-prod.appspot.com';
export const PAY_URL_PRODUCTION = "https://rebus-v4-pay-prod.herokuapp.com";
export const AI_URL_PRODUCTION = "https://rebus-v4-prod.appspot.com";
export const BACKEND_PRODUCTION = "https://rebus-v4-prod.herokuapp.com";
export const BACKENDV5_PRODUCTION = "https://rebus-v5-dev.herokuapp.com";
export const XLS_TEMPLATES_PRODUCTION = {
  // tslint:disable-next-line:max-line-length
  "7-user-email": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "8-user-code": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "endpoint1": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "upload_calendars": "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/templateExcel%2Fupload_calendars.xlsx?alt=media&token=894e3136-c630-4c69-9956-ebe6a665fcfc",
  // tslint:disable-next-line:max-line-length
  "users": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Templates%2Fupload_users_03122018.xlsx?alt=media&token=2cd0c1ab-a104-4dad-9abb-fead35484e67",
  // tslint:disable-next-line:max-line-length
  "users_club": "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/templates%2FplantillaClubes.xlsx?alt=media&token=ee05be9d-ca4a-4b4e-ae7b-69047bd6965b",
  // tslint:disable-next-line:max-line-length
  "users_payment_club": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/datos_de_club.xlsx?alt=media&token=166f6104-f8b8-412c-8612-3e11edbb01ad",
  // tslint:disable-next-line:max-line-length
  "users_upload_coupons": "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Plantilla%20carga%20cupones.xlsx?alt=media&token=633c85d8-2288-4b4b-8ddc-2ccd2f97988d",
};
export const LANGUAGES_PRODUCTION = [
  { key: "es", value: "Spanish" },
  { key: "en", value: "English" },
];
export const FIREBASE_PRODUCTION = {
  apiKey: "AIzaSyC2scnthFYp6G_sZ3Qinui90T7kgW_evgk",
  authDomain: "rebus-v4-prod.firebaseapp.com",
  databaseURL: "https://rebus-v4-prod.firebaseio.com",
  messagingSenderId: "519996567265",
  projectId: "rebus-v4-prod",
  storageBucket: "rebus-v4-prod.appspot.com",
};
// -------------------------------------------------------------------------------



// WEBPACK FOOTER //
// ./src/environments/global.ts